var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"jitsi-iframe",attrs:{"id":"jitsi"}},[(_vm.loading)?_c('loading-icon',{attrs:{"expand":""}}):_vm._e(),(_vm.afterLoadTimeout)?_c('div',{staticClass:"emergency-leave",on:{"click":_vm.handleLeaveRoom}},[_vm._v("Leave Room")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }